<script src="node_modules/jquery/dist/jquery.min.js"></script>
<!-- Content Header (Page header) -->
<!--<section class="content-header bg-white p-3 mt-3 mx-1 rounded" style="background: white;" >
    <div class="d-flex justify-content-between pt-1 align-items-center">
        <h3><strong>Dashboard</strong></h3>
    </div>
</section>-->

<!--*********************************************************************************************************************************************************************************************************************************-->
<link href="https://unpkg.com/bootstrap-css-only@4.4.1/css/bootstrap.min.css" rel="stylesheet">
<link href="https://unpkg.com/@fortawesome/fontawesome-free@5.15.1/css/all.css" rel="stylesheet">
<link href="https://unpkg.com/angular-calendar@0.28.22/css/angular-calendar.css" rel="stylesheet">
<link href="https://unpkg.com/flatpickr@4.6.6/dist/flatpickr.css" rel="stylesheet">


<section class="d-flex justify-content-between content-header w-100  mt-4 p-3 mb-3 mx-1 rounded text-white bg-dark"  >
    <div class=" pt-1 align-items-center">
        <h3 ><strong translate>Dashboard - {{branch}}</strong></h3>
    </div>
    <div class=" pt-1 align-items-center" >
     
        <button class="btn btn-dark mx-1 border border-white rounded text-white " (click)='scrollToTableView()' translate>Today's Schedules Table View</button>

        <button class="btn btn-dark mx-1 border border-white rounded text-white " routerLink="/create-logistics-schedules" translate>Create Pick-up Schedule</button>
    
    </div>
</section>

<div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-5 " style="min-width: 48%;"  >

<mwl-demo-utils-calendar-header
  [(view)]="view"
  [(viewDate)]="viewDate"
  (viewDateChange)="fetchEvents()"
  (viewChange)="fetchEvents()"
>
</mwl-demo-utils-calendar-header>

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-5x"></i> <br />
    Loading events...
  </div>
</ng-template>

<div *ngIf="events$ | async; else loading; let events">
  <div [ngSwitch]="view">
    <mwl-calendar-month-view
      *ngSwitchCase="'month'"
      [viewDate]="viewDate"
      [events]="events"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="'week'"
      [viewDate]="viewDate"
      [events]="events"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="'day'"
      [viewDate]="viewDate"
      [dayStartHour]="8"
      [dayEndHour]="18"
      [events]="events"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-day-view>
  </div>
</div>
<!--*********************************************************************************************************************************************************************************************************************************-->
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

            <!-- Indicators -->
            <ul class="carousel-indicators">
                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                <li data-target="#assetSlide" data-slide-to="1"></li>
                <li data-target="#assetSlide" data-slide-to="2"></li>
            </ul>

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Today's Schedules</strong>   <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
                       
                        <th class=" p-2" translate>Full Name</th>
                        <th class="text-center p-2" translate>Invoice #</th>
                        <th class="text-center p-2" translate>Phone</th>
                        <th class="text-center p-2" translate>Time In</th>
                        <th class="text-center p-2" translate>Time Out</th>
                        <th class="text-center p-2" translate>Date Submitted</th>
                        <th class="text-center p-2" translate>Status</th>
                        <th class="text-center p-2" translate>Action</th>
                       
                       
                       <tr  *ngFor='let list of alltodaysschedules | filter:searchText'>
                            <td class="p-2" (click)=openSchedule(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                            <td class="text-center p-2" (click)=openSchedule(list) style="cursor: pointer;"  >{{list.invoiceNumber}}</td>
                           <td class="text-center p-2" (click)=openSchedule(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                           <td class="text-center p-2" (click)=openSchedule(list) style="cursor: pointer;" >{{list.pickupTimetimeIn | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center p-2" (click)=openSchedule(list) style="cursor: pointer;" >{{list.checkOut | date:'yyyy-M-d h:mm a'}}</td>
                           <td class="text-center p-2" (click)=openSchedule(list) style="cursor: pointer;" >{{list.dateSubmitted | date:'yyyy-M-d h:mm a'}}</td>
                          
                          
                          
                           <td  *ngIf="list.status==''" class="text-warning text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-2" ><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-2"><strong>{{list.status}}</strong></td>
                            <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-2"><strong>{{list.status}}</strong></td>

                            <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                <i class="fa fa-trash p-2" style="cursor: pointer;"(click)="deleteSchedule(list)"></i>
                                <i class="fa fa-edit text-info p-2" style="cursor: pointer;" (click)="editSchedule(list)" ></i>
                                <i class="fa fa-check-square text-success p-2" style="cursor: pointer;" (click)="completeSchedule(list)"></i></td>
                           
                           
                       
                    
                          

                       
                        </tr>
                    </table>
               </div>
                    </div>
                </div>

              <!--  <div class="carousel-item ">
                    <div class=" border p-3 m-1 rounded  " >
                        <h6 class="table-heading   rounded text-white bg-info text-center p-3"><strong>Training Notification</strong></h6>
                   
                        <div  style=" height: 200px; overflow:auto;"  >
                            <table class="table w-100 text-center"  style=" font-size: 12px;">
                           <thead>
                                <th class=" p-2" >Employee</th>
                                <th class=" text-center p-2" >Training Name</th>
                                <th class="text-center p-2" >Days Remaining</th>
                                <th class="text-center p-2" >Expiry Date</th>
                            </thead>
                             <tbody class="pt-4" style="overflow:auto;">
                                <tr *ngFor='let list of allexpiringtraining'>
                                    <td  >{{list.fullName}}</td>
                                    <td class="text-center " routerLink="/training-main">{{list.trainingName}}</td>
                                    <td  *ngIf="list.daysremain <= 30 && list.daysremain > 20" class="text-success text-center  p-2" ><strong>{{list.daysremain}}</strong></td>
                                    <td  *ngIf="list.daysremain  <= 20 && list.daysremain > 10" class="text-warning text-center  p-2" ><strong>{{list.daysremain}}</strong></td>
                                    <td  *ngIf="list.daysremain  <= 10 && list.daysremain >= 0" class="text-danger text-center  p-2"><strong>{{list.daysremain}}</strong></td>
                                   
                                    <td class="p-1 text-center">{{list.expiry}}</td>
                               
                                </tr>
                            </tbody>
                            </table>
                                
                        </div>
                </div>
                </div>-->
            
            </div>

            <!-- Left and right controls -->
       <!--     <a class="carousel-control-prev " href="#notificationSlide"  data-slide="prev">
                <span class="carousel-control-prev-icon"></span>
            </a>
            <a class="carousel-control-next"   href="#notificationSlide" data-slide="next">
                <span class="carousel-control-next-icon"></span>
            </a>--->
        </div>
      
</div>

 
  <!--  <div class="col-md-3">
   <div class=" border p-3 m-1 rounded border-secondary  " >
  <h5 class="table-heading    text-white bg-info text-center p-3" style="border: 6px solid #044536; border-radius: 5%; font-family: 'Trebuchet MS';"><strong>Training Notification</strong></h5>
  <div class="p-2" style="overflow:auto; max-height: 200px; background-color: whitesmoke;"  >
  <table class="w-100 " >
     
      <tr *ngFor="let employee of employees">
          <td class="p-2"  style="font-family: 'Trebuchet MS';">
              {{employee.fullName}}
          </td>
      </tr>
  </table>
  </div>
</div>
    </div>-->



            
    <!--Bar Stacked TotalAsset chart Horizontal-->
<!--<div class="  col-md-5 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width:48%; "  >
    <canvas id="stackedchart" style="max-width:100% ;"></canvas>
          </div> -->
       
        </div>

        </div>










        <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Complete Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessCompleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessCompleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessCompleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>This has been marked as complete.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getTodaysSchedule()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>



        

         
         

        <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success DeleteModal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessDeleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Schedule has been deleted.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getTodaysSchedule()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    
                    
                    <!------------------------------------------------------------------------------------------------------------------------------------------
                                           Error Modal
                                        ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="ErrorModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                                    <h4 class="modal-title text-danger" translate>ERROR</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body text-danger">
                                    <p>{{error}}</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" routerLink='/main-dashboard' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
</div>

                    











                        